export const routes = {
  headcount: '/headcount/:tab',
}
